import styled from "styled-components"

import { topBarSize, leftBarSize } from "../../Components/NavBar/styles";

export const Container = styled.div`  
    position: absolute;
    top: calc(${topBarSize});
    left: calc(${leftBarSize});

    width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
    height: calc(100% - calc(${topBarSize} + 2rem)) !important;

    padding-top: 1rem;
    padding-left: 1rem;


    z-index: 1;
`;

export const Title = styled.p`
    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: rgba(55, 73, 87, 0.7);
    font-size: 2rem;

    z-index: 2;

    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;

    -ms-flex-align: center;
    -webkit-align-items: center;
    
`;

export const DataGridButton = styled.button<{ color?: string }>`
    margin-right: 1rem;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: ${({ color }) => color || "#0090C1"};

    background: none;
    border: 2px solid ${({ color }) => color || "#0090C1"};
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const Button = styled.button`
    position: absolute;
    right: 0%;

    height: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;

    text-transform: uppercase;
    font-family: 'Roboto';
    font-weight: 900;
    color: #2E933C;

    background: none;
    border: 2px solid #2E933C;
    border-radius: 20px;

    cursor: pointer;

    &:hover{
        background: rgba(55, 73, 87, 0.1);
        transition-duration: 0.1s;
    }

    &:active{
        background: rgba(55, 73, 87, 0.2);
        transition-duration: 0.1s;
    }

    z-index: 3;
`;

export const UserDeleteOptions = styled.a`
    cursor: pointer;

    &:hover{
        opacity: 0.5;
    }
`;

export const UserDeleteOptionsRed = styled(UserDeleteOptions)`
    color: #DB3A34;
`;

export const UserDeleteOptionsGreen = styled(UserDeleteOptions)`
color: #2E933C;
`;

export const ReviewModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  min-width: 350px;

  h2 {
    margin: 0;
    color: #374957;
    font-size: 1.5rem;
  }
`;

export const ReviewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &.buttons {
    flex-direction: row;
    justify-content: flex-end;
    gap: 1rem;
  }
`;

export const ReviewLabel = styled.label`
  color: gray;
  font-size: 0.875rem;
  font-weight: 500;
`;

export const ReviewSelect = styled.select`
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.875rem;
  font-family: 'Roboto';
  background-color: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #2E933C;
    box-shadow: 0 0 0 2px rgba(46, 147, 60, 0.1);
  }
`;

interface ReviewButtonProps {
  cancel?: boolean;
}

export const ReviewButton = styled.button<ReviewButtonProps>`
  padding: 0.75rem 1.5rem;
  border: 1px solid ${(props) => (props.cancel ? "#ddd" : "#2E933C")};
  background-color: ${(props) => (props.cancel ? "transparent" : "#2E933C")};
  color: ${(props) => (props.cancel ? "#374957" : "white")};
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Roboto';
  transition: all 0.2s;

  &:hover {
    background-color: ${(props) => (props.cancel ? "#f0f0f0" : "#247a2f")};
  }

  &:active {
    background-color: ${(props) => (props.cancel ? "#e0e0e0" : "#1d6127")};
  }
`;